import { MessageCircle, FileText, Wrench } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    num: "01",
    icon: MessageCircle,
    title: "Raccontaci il tuo ufficio",
    text: "Scrivici su WhatsApp o chiamaci: quante persone siete, quanto stampate, cosa vi serve davvero.",
  },
  {
    num: "02",
    icon: FileText,
    title: "Ricevi il preventivo",
    text: "Ti proponiamo la multifunzione giusta con un canone mensile chiaro: toner, ricambi e assistenza inclusi.",
  },
  {
    num: "03",
    icon: Wrench,
    title: "Installiamo e ci pensiamo noi",
    text: "Consegna e configurazione di rete in giornata. Da quel momento toner e assistenza entro 24h sono affare nostro.",
  },
];

export const ComeFunziona = () => (
  <section id="come-funziona" data-testid="how-section" className="py-24 sm:py-32 border-b border-[#E5E2DC]">
    <div className="px-6 sm:px-12 lg:px-20 max-w-7xl mx-auto">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#C85A32] mb-4">Come funziona</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-[1.1] text-[#181817] max-w-2xl">
          Tre passi. Zero pensieri.
        </h2>
      </Reveal>
      <div className="mt-16 grid md:grid-cols-3 gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12}>
            <div
              data-testid={`how-step-${s.num}`}
              className="group h-full bg-[#F3F0EA] border border-[#E5E2DC] rounded-sm p-8 sm:p-10 flex flex-col hover:-translate-y-1.5 transition-transform duration-500"
            >
              <div className="flex items-start justify-between">
                <span className="font-display text-5xl font-light text-[#C85A32]">{s.num}</span>
                <span className="w-11 h-11 rounded-full bg-[#181817] text-[#FBF9F5] flex items-center justify-center group-hover:bg-[#C85A32] transition-colors duration-500">
                  <s.icon size={18} />
                </span>
              </div>
              <h3 className="mt-8 font-display text-2xl font-light text-[#181817] leading-snug">{s.title}</h3>
              <p className="mt-4 text-sm text-[#181817]/70 leading-relaxed">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
